<template>
<div>
  <router-view />
</div>
</template>

<script>

export default {
  name: 'mobileUnit',
  components: {
  }
}
</script>
<style lang="less" scoped>
</style>
